import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  addPartnerDurationApi,
  deletePartnerDurationApi,
  getPartnerDurationApi,
  updatePartnerDurationApi,
} from "../../../services/partners/settings/partnerDurationService";

export const getAllPartnerDuration = createAsyncThunk("partner/getAllPartnerDuration", async (filters, { dispatch }) => {
  const response = await getPartnerDurationApi(filters);
  return response.response;
});

export const addPartnerDuration = createAsyncThunk("partner/addPartnerDuration", async (duration, { dispatch, getState }) => {
  try {
    const response = await addPartnerDurationApi(duration);
    const data = await response.response;
    toast.success("Add Partner Duration successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerDuration = createAsyncThunk("partner/updatePartnerDuration", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updatePartnerDurationApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update partner duration successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletepartnerDuration = createAsyncThunk("partner/deletepartnerDuration", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deletePartnerDurationApi(id);
    const data = await response.response;
    toast.success("Deleted partner duration successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnersDurationAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerDuration, selectById: selectPartnerDuratoinById } = partnersDurationAdapter.getSelectors(
  (state) => state.partner.partnerDuration
);

const partnerDurationSlice = createSlice({
  name: "partnerDuration",
  initialState: partnersDurationAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerDuration",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerDurationSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerDuration",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerDuration.fulfilled]: partnersDurationAdapter.setAll,
  },
});

export const { setPartnerDurationSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerDurationSlice.actions;

export default partnerDurationSlice.reducer;
